import React from 'react';

const GeneralVision = ({ formData, handleChange, handleSave }) => {
  return (
    <div className="space-y-10">
      {/* Configuración básica */}
      <section>
        <h3 className="text-lg font-semibold text-blue-800">Configuración básica</h3>
        <p className="text-sm text-gray-600 mb-4">
          Aquí puede actualizar el nombre, permiso y las preferencias de notificación de este cliente.
        </p>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700">Nombre</label>
            <input
              name="first_name"
              value={formData.first_name || ''}
              onChange={handleChange}
              className="mt-1 w-full border border-gray-300 rounded-md p-3"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Apellido</label>
            <input
              name="last_name"
              value={formData.last_name || ''}
              onChange={handleChange}
              className="mt-1 w-full border border-gray-300 rounded-md p-3"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Rol</label>
            <select
              name="role"
              value={formData.role || ''}
              onChange={handleChange}
              className="mt-1 w-full border border-gray-300 rounded-md p-3"
            >
              <option value="admin">Administrador</option>
              <option value="customer">Cliente</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Estado</label>
            <select
              name="status"
              value={formData.status || ''}
              onChange={handleChange}
              className="mt-1 w-full border border-gray-300 rounded-md p-3"
            >
              <option value="active">Activo</option>
              <option value="inactive">Inactivo</option>
              <option value="suspended">Suspendido</option>
              <option value="pending">Pendiente</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Número de cliente</label>
            <input
              type="text"
              disabled
              value={formData.user_id || ''}
              className="mt-1 w-full bg-gray-100 border border-gray-300 rounded-md p-3 cursor-not-allowed"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Fecha de cumpleaños</label>
            <input
              type="date"
              name="birth_date"
              value={formData.birth_date || ''}
              onChange={handleChange}
              className="mt-1 w-full border border-gray-300 rounded-md p-3"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Cliente desde</label>
            <input
              type="text"
              disabled
              value={formData.created_at ? new Date(formData.created_at).toLocaleDateString() : ''}
              className="mt-1 w-full bg-gray-100 border border-gray-300 rounded-md p-3 cursor-not-allowed"
            />
          </div>
        </div>
      </section>

      {/* Correos electrónicos */}
      <section>
        <h3 className="text-lg font-semibold text-blue-800">Correos electrónicos</h3>
        <p className="text-sm text-gray-600 mb-4">
          Aquí puede administrar los diferentes correos electrónicos vinculados a esta cuenta de cliente.
        </p>
        <div>
          <label className="block text-sm font-medium text-gray-700">Correo electrónico</label>
          <input
            type="email"
            name="email"
            value={formData.email || ''}
            onChange={handleChange}
            required
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
            className="mt-1 w-full border border-gray-300 rounded-md p-3"
          />
        </div>
      </section>

      {/* Teléfonos */}
      <section>
        <h3 className="text-lg font-semibold text-blue-800">Teléfonos</h3>
        <p className="text-sm text-gray-600 mb-4">
          Aquí puede administrar los diferentes números de teléfono vinculados a esta cuenta de cliente.
        </p>
        <div>
          <label className="block text-sm font-medium text-gray-700">Número de teléfono</label>
          <input
            type="tel"
            name="phone_number"
            value={formData.phone_number || ''}
            onChange={handleChange}
            className="mt-1 w-full border border-gray-300 rounded-md p-3"
          />
        </div>
      </section>

      {/* Botón guardar cambios */}
      <div className="pt-4 border-t">
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-[oklch(54.6%_0.245_262.881)] text-white rounded hover:bg-[oklch(54.6%_0.245_262.881)]"
        >
          Guardar Cambios
        </button>
      </div>
    </div>
  );
};

export default GeneralVision;
